<template>
    <span v-if="status === PayyoPaymentStatus.SUCCEEDED"
          class="label label-success">
        {{ l('PAYYO_STATUS_BADGE.SUCCEEDED') }}
    </span>
    <span v-else-if="status === PayyoPaymentStatus.FAILED"
          class="label label-danger">
        {{ l('PAYYO_STATUS_BADGE.FAILED') }}
    </span>
    <span v-else-if="status === PayyoPaymentStatus.CANCELED"
          class="label label-default">
        {{ l('PAYYO_STATUS_BADGE.CANCELLED') }}
    </span>
    <span v-else
          class="label label-warning">
        {{ l('PAYYO_STATUS_BADGE.ABANDONED') }}
    </span>
</template>

<script>
import PayyoPaymentStatus from '@/lib/PaymentMethods/Payyo/Enums/PayyoPaymentStatus';

// Please note: this is a very simplified handling of the PayyoPaymentStatus designed for use in the
// PayyoManualReconciliationModal - if this is gets used elsewhere it will probably be appropriate to
// modify this and make it a bit more fine-grained.
export default {
    name: 'PayyoSimpleStatusBadge',

    props: {
        status: {
            type: String,
            default: null,
        },
    },

    computed: {
        PayyoPaymentStatus() {
            return PayyoPaymentStatus;
        },
    },
};

</script>
